/*
* Entity notes wrapper component for views
*/

import * as React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import { RouteComponentProps } from 'react-router-dom';
import { Row } from 'react-bootstrap';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as AppComp from '../app-component-base';
import * as AppUtilities from '../apputilities';
import * as ReduxQueries from '../../queries';
import AppConfiguration from '../../config/configuration';
import { BootstrapColXl as Col } from '../bootstrap/bootstrapcolxl';
import { Formatters } from '../formatters';

export interface IEntityNotesProps extends AppComp.IAppComponentProps {
    notes?: any;
}

class EntityNotes extends AppComp.AppComponent<IEntityNotesProps, any> {
    public MomentDateFormat: string = AppConfiguration.getMomentShortDateFormat();

    public MomentDateTimeFormat: string = AppConfiguration.getMomentDateTimeFormat();

    public constructor(props: IEntityNotesProps) {
        super(props, 'app.entity-notes.');
    }

    public renderNotes(notes: Array<any>) {
        if (!AppUtilities.isArrayWithLength(notes)) { return []; }

        return notes.map((val, ind) => {
            const authorName = Formatters.composeUsernameLabel({ contact: _.get(val, 'author') }, true);

            return (
                <Row key={ind}>
                    <Col xs={12}>
                        <div className="order-note-header small-link-text">{`${this.appText('on')} ${moment(new Date(_.get(val, 'created'))).format(this.MomentDateTimeFormat)} ${authorName} ${this.appText('wrote')}:`}</div>
                        <p className="order-note-content">{_.get(val, 'notes')}</p>
                    </Col>
                </Row>
            );
        });
    }

    public render() {
        const notes = this.renderNotes(this.props.notes);

        return (
            <div>{notes}</div>
        );
    }
}

const mapStateToProps = (state: AppComp.IAppComponentState, props): IEntityNotesProps => {
    const mapped = ReduxQueries.MapQueryStateToPropsRoot(state, props, null);

    return mapped;
};

const t = connect(mapStateToProps, {})(EntityNotes);
export default withRouter<IEntityNotesProps>(t);



// WEBPACK FOOTER //
// ./src/common/entitydetail/entitynotes.tsx